module.exports = __webpack_public_path__ + "a22840fae5ed1055874bef0264ec8539.svg";